//import logo from './logo.svg';
import React, { useEffect, useState } from 'react'



import Header from './components/Header/Header';

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MiddleHeader from './components/Header/MiddleHeader';
import UsersView from './Rutas/Users/UsersView';


import Footer from './components/Footer/Footer';


import AddLawer2 from './components/Lawers/AddLawer2';

import AddClient2 from './components/Client/AddClient2';
import ConsultaExpress from './components/ConsultaExpress/ConsultaExpress';
import PagoAux from './components/PagoAux/PagoAux';
import Admin from './components/Admin/Admin';
import LogIn from './components/Log_in/LogIn';
import LawyerDash from './components/Lawers/LawyerDash';
import ClientDash from './components/Client/ClientDash';
import Meeting from './components/Login/Meeting/Meeting';
import Pagos  from './components/Pagos/Pagos'
import SocketClient from './SocketClient/SocketClient';


import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import TestDashboard from './components/Lawers/TestDashboard/TestDashboard';


//import Info from './components/Client/Auxiliar/Modal';
import ClientMenu from './components/Client/Gerry/ClientMenu/ClientMenu';
//import AgendaUnaCita from './components/Client/Auxiliar/AgendaUnaCita';

import AgendaUnaCita from './components/Client/Gerry/ClientMenu/AgendaUnaCita/AgendaUnaCita'
import Info from './components/Client/Gerry/ClientMenu/AgendaUnaCita/Modal';






const customStyles = {
  content: {
    top: '55%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-40%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'lightgray',
    borderRadius: '10px',
    width: '1000px'
  },
};


function App() {

  const [showMiddle, setShowMiddle] = useState(true);
  const [theLogin, setTheLogin] = useState(false)
  const [showSidebar, setShowSidebar] = useState(true);

  const [modalMessage, setModalMessage] = useState(""); // Este es el mensaje
  const [modalTitle, setModalTitle] = useState("") // Este es el titulo
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [showAbogados, setShowAbogados] = useState(false)

  let subtitle;


  //let navigate = useNavigate() ;

  useEffect(() => {




    window.onpopstate = e => {
      setShowMiddle(true)
      setShowAbogados(false)
    }


    console.log( "cargando onbeforeunload") ; 


    window.addEventListener( "beforeunload" , handleclose)

    return () => {
      console.log( "desmontando onbeforeunload") ;
       window.removeEventListener("beforeunload", handleclose)
    }


  }, [])


  const handleclose = (event) =>{
    event.preventDefault() ;
    event.returnValue = "Esta seguro de abandonar la sesion" ;
  }


  function closeModal() {

    setIsOpen(false)
  }

  function afterOpenModal() {
    subtitle.style.color = '#f00';
  }


  function showTheLogin(value) {

    console.log( "en App = " + value )

    if (value === "/session") {
      console.log( "Nos Vamos a session")
      setTheLogin(!theLogin)
      return;
    }

    if (value === "/abogados") {
      //alert( "Soy abogado") ;

      setShowAbogados(true)

      setModalTitle("Alta abogado")
      setIsOpen(true);

      //navigate( "/abogados" )
    }

    if (value === "/clientes") {
      //alert( "Soy abogado") ;

      setShowAbogados(true) // Y clientes

      setModalTitle("Alta abogado")
      setIsOpen(true);

      //navigate( "/abogados" )
    }

    if (value === "/") {
      setShowAbogados(false) // Y clientes

    }

    console.log( "No lo encontramos")

  }

  return (
    <div className="App" style={{ backgroundColor: 'white' }}>
      <BrowserRouter>
        <Header select={showTheLogin} showSide={showSidebar} ></Header>
        {
          true && (
            <SocketClient/>
          )
        }





        <Routes>

          <Route path="/" loader={() => console.log("Cargando middleHeader(2)")} element={

            <>
              {/* <Header select={showTheLogin} showSide={showSidebar} /> */}

              {(showMiddle && !showAbogados) && (
                <MiddleHeader showLogin={theLogin} setShowSide={(val) => setShowSidebar(val)}></MiddleHeader>
              )
              }



            </>
          }>

          </Route>


          <Route path="/users" Link="./Rutas/Users/UsersView"
            element={<UsersView setShowMiddle={setShowMiddle}></UsersView>} />


          <Route path="/abogados"
            element={<AddLawer2></AddLawer2>} />

          <Route path="/clientes"
            element={<AddClient2></AddClient2>} />

          <Route path="/express" element={<ConsultaExpress/>} />
          <Route path="/Admin" element={<Admin></Admin>} />
          <Route path="/session" element={<LogIn></LogIn>} /> 
          {/*<Route path="/session" element={<Servicios/>} />*/}
          <Route path="/lawyerdash" element={<LawyerDash/>} />
          <Route path="/clientdash" element={<ClientDash/>} />
          <Route path="clientmenu" element={<ClientMenu/>} />
          <Route path="/agenda" element={<AgendaUnaCita/>} />
          {/* <Route path="/consultaexpress" element={<ConsultaExpress/>} /> */}
          <Route path="/meeting" element={<Meeting/>} />
          <Route path="/pagos" element={<Pagos/>} />
          <Route path="/testdashboard" element={<TestDashboard/>} />
          <Route path='/info' element={<Info/>}/>


          {/* <Route path="/besview" Link="./components/BesCustomer/BesView" element={<BesViewPrev></BesViewPrev>} /> */}

        </Routes>
      </BrowserRouter>
      {/*{
        !showAbogados && false  && (
          <>
          
            <AddLawer2/>
            <AddClient2></AddClient2>
          </>
        ) 
      } */}

    </div>
  );
}

export default App;
